module.exports = {
  BASE_HOST: process.env.BASE_HOST || 'localhost',
  API_HOST: process.env.API_HOST || 'localhost',
  LOCALE: process.env.LOCALE || 'ja',
};
